const header = document.querySelectorAll('.education__moduleheader');

header.forEach((node) => {
    node.addEventListener('click', () => {
        const parent = node.closest('.education__module');
        parent.classList.toggle('education__module--open');
    });
});